import { darken, lighten } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { getGridSurface } from '../../../../../../../orders/styles/gridScrollFade';

const GRID_STOCK_LABEL_SPACE = 6;
const GRID_INPUT_BORDER_SPACE = 2;
const ROW_BACKGROUND_BLEED = 8;
const ROW_VERTICAL_PADDING = 2;
const ROW_WITH_IMAGE_MOBILE_VERTICAL_PADDING = 8;

const SELECTED_SURFACE_LIGHT_MIX = 0.88;
const SELECTED_SURFACE_LIGHT_HOVER_MIX = 0.8;
const SELECTED_SURFACE_DARK_MIX = 0.78;
const SELECTED_SURFACE_DARK_HOVER_MIX = 0.7;

interface UseStylesProps {
  height: number;
  gridScrollerClassName: string;
}

export const useCombinationLineStyles = makeStyles<UseStylesProps>()(
  (theme, { height, gridScrollerClassName }) => {
    const brandOrange = theme.palette.custom.teceo.orange;
    const isDarkMode = theme.palette.mode === 'dark';

    const selectedSurface = isDarkMode
      ? darken(brandOrange, SELECTED_SURFACE_DARK_MIX)
      : lighten(brandOrange, SELECTED_SURFACE_LIGHT_MIX);

    const selectedHoverSurface = isDarkMode
      ? darken(brandOrange, SELECTED_SURFACE_DARK_HOVER_MIX)
      : lighten(brandOrange, SELECTED_SURFACE_LIGHT_HOVER_MIX);

    return {
      root: {
        height: height + ROW_VERTICAL_PADDING * 2,
        padding: `${ROW_VERTICAL_PADDING}px 0px`,
        borderRadius: theme.shape.borderRadiusLg,
        [`& .${gridScrollerClassName}`]: {
          paddingBottom: `${GRID_STOCK_LABEL_SPACE}px !important`,
          paddingLeft: GRID_INPUT_BORDER_SPACE,
        },
      },
      combinationWithoutImagePadding: {
        padding: `2px ${ROW_BACKGROUND_BLEED}px`,
        marginInline: -ROW_BACKGROUND_BLEED,
        [theme.breakpoints.down('sm')]: {
          padding: theme.spacing(0.25, 1.5),
          marginInline: 0,
        },
      },
      combinationWithImagePadding: {
        padding: `2px ${ROW_BACKGROUND_BLEED}px`,
        marginInline: -ROW_BACKGROUND_BLEED,
        [theme.breakpoints.only('xs')]: {
          padding: `${ROW_WITH_IMAGE_MOBILE_VERTICAL_PADDING}px 12px`,
          marginInline: 0,
          height: height + ROW_WITH_IMAGE_MOBILE_VERTICAL_PADDING * 2,
        },
      },
      isSelected: {
        backgroundColor: selectedSurface,
        borderRadius: theme.shape.borderRadiusLg,
        ...getGridSurface({ base: selectedSurface }),

        '&:hover': {
          backgroundColor: selectedHoverSurface,
          ...getGridSurface({ base: selectedHoverSurface }),
        },
      },
    };
  },
);
